module.exports = __webpack_public_path__ + "static/media/header_presentbox5825b6e855af55b1495d66d9342c1504.webp";